import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Styles = styled.div``;

const SelectTipoTicket = ({id, value, onChange, isInvalid, isClearable}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const tipoTk = useSelector(state => state.default.tipoTk);

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        setItems(tipoTk);
    }, [tipoTk]);

    useEffect(() => {
        const newOptions = items.map((item) => {
            return {
                value: item.id_ttk,
                label: item.nombre_ttk
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === Number(value))
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>({label:va.nombre_ttk,value:va.id_ttk})));
        }else{
            setSelectedValue(null);
        }
    }, [items,value])
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectTipoTicket.defaultProps = {
    isClearable: false
};

export default SelectTipoTicket;
